const FFL_TOKEN_REGEX = /\bffl\b/i;
const FFL_NORMALIZE_REGEX = /[_\-]+/g;

function normalizeFflSource(source) {
  if (typeof source !== 'string') return '';
  return source.replace(FFL_NORMALIZE_REGEX, ' ');
}

export function isFflStadiumName(name) {
  const normalized = normalizeFflSource(name);
  if (!normalized) return false;
  return FFL_TOKEN_REGEX.test(normalized);
}

export function isFflSevenAsideMatch(match = {}) {
  const minutes = Number(match.minutes ?? match.gameMinutes ?? match.durationMinutes);
  const hasMinutes = Number.isFinite(minutes) ? minutes >= 9 : false;
  const stadiumName = match.stadium?.name || match.stadiumName || match.mapName || match.map?.name || '';
  const inferredFromTitle = isFflStadiumName(stadiumName);
  const inferredFromFile = typeof match.mapFile === 'string' && isFflStadiumName(match.mapFile);
  return Boolean((inferredFromTitle || inferredFromFile) && hasMinutes);
}

export function getFflMapFingerprint(match = {}) {
  const mapName = match.stadium?.name || match.stadiumName || match.mapName || null;
  const mapFile = typeof match.mapFile === 'string' ? match.mapFile : null;
  const mapHash = typeof match.mapHash === 'string' ? match.mapHash : null;
  return {
    mapName: mapName || null,
    mapFile,
    mapHash
  };
}
